module.exports = __webpack_public_path__ + "static/flags/AT-c10acb848f56dc40e190a89f0e57576d.gif";